import { lazy } from 'react';

export const RedirectPageLazy = lazy(() => import('./redirect-page'));
